export enum ProjectManagementViewByEnum {
  Applicant = 1,
  GmaWbProject = 2,
  ProjectOrderNumber = 3,
}
